<template>
  <div class="menu-items">
    <h1 v-if="category_name" class="title">{{ category_name }}</h1>
    <h1 v-else class="title">All Menu Items</h1>

    <div
      v-if="is_loading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <div v-else class="row mt-2 px-4 mx-0">
      <p v-if="menu_items.length == 0">No menu items exist!</p>

      <div
        v-else
        v-for="(menu_item, index) in menu_items"
        :key="menu_item.id"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-sx-12"
      >
        <menu-item-card
          :object_id="menu_item.id"
          :title="menu_item.attributes.name"
          button_text="Add to Cart"
          button_classes="bg-white text-primary border-0"
          :image_source="menu_item.attributes.image_url"
          :card_classes="menu_item.attributes.status == 'out_of_stock' ? 'm-4 mb-2 menu-item-card disable-card' : 'm-4 mb-2 menu-item-card'"
          @card_button_click="show_menu_item(menu_item.id)"
          :favourite_links="true"
          :is_favourite="menu_item.attributes.favourite"
          :price="menu_item.attributes.price"
          @favourite_button_click="toggle_favourite_items(menu_item.id, index, menu_item.attributes.favourite, menu_item.attributes.favourite_item_id)"
          :out_of_stock="menu_item.attributes.status == 'out_of_stock' ? true : false"
        ></menu-item-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenuItems, createFavouriteItem, destroyFavouriteItem } from '../store/api'
import Card from "../components/card";

export default {
  name: 'menu_items',

  components: {
    'menu-item-card': Card,
  },

  data() {
    return {
      category_name: this.$route.params.category_name,
      menu_items: [],
      is_loading: true,
    }
  },

  created() {
    getMenuItems({
      search: { category_id_eq: this.$route.params.category_id }
    })
      .then(response => {
        this.menu_items = response.data
        this.is_loading = false
      })
      .catch(error => this.is_loading = false)
  },

  methods: {
    show_menu_item(menu_item_id) {
      this.$router.push(`menu_items/${menu_item_id}`)
    },
    toggle_favourite_items(menu_item_id, index, is_favourite, favourite_item_id) {
      if(is_favourite) {
        this.menu_items[index].attributes.favourite = false
        destroyFavouriteItem(favourite_item_id)
      } else {
        this.menu_items[index].attributes.favourite = true
        createFavouriteItem({ menu_item_id: menu_item_id })
          .then(response => this.menu_items[index].attributes.favourite_item_id = response.data.id)
      }
    },
  },

  beforeCreate: function() {
    document.body.className = '';
  },
}
</script>

<style scoped>
  .menu-items {
    text-align: center;
  }
  .row {
    justify-content: center;
  }
</style>
